import { render, staticRenderFns } from "./AppTypeRadio.vue?vue&type=template&id=2116ec25&scoped=true&lang=pug"
import script from "./AppTypeRadio.vue?vue&type=script&lang=js"
export * from "./AppTypeRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2116ec25",
  null
  
)

export default component.exports